import React, { FC, useState } from 'react';
import IconCerdito from '../../../Icons/IconCerdito';
import IconCalendarioTarjeta from '../../../Icons/IconCalendarioTarjeta';
import IconPorcentaje from '../../../Icons/IconPorcentaje';
import clubCreditoCaprabo from '../../../assets/images/club-credito-caprabo.png';
import TarjetaForm from './form/solicitudTarjetaForm';
import AdicionalModal from './form/adicionalModal';
// import { useTranslation } from 'react-i18next';
// import useAPIError from '../../hooks/useAPIError';
// import { useAuthStore } from '../../store/AuthContext';
// import { useAppStore } from '../../store/AppContext';

const TitularTpecCaprabo: FC = () => {
  // const { t } = useTranslation();
  // const dataUser = useAuthStore();
  // const dataApp = useAppStore();
  // const { addError, addErrorBack } = useAPIError();

  const [showSolicitud, setShowSolicitud] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  // useEffect(() => {
  //   if (dataUser.user.token !== '') retrieveSaldo();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [i18n.language]);
  return (
    <>
      <section className="header-tarjetas tarjetas">
        <div className="container">
          <div className="header-tarjetas__content">
            <h1 className="header-tarjetas__title">Tarjetas</h1>
            <div className="bloque-etiquetas">
              <span className="etiqueta">Eroski Club</span> +{' '}
              <span className="etiqueta">Tarjeta de crédito</span>
            </div>
            <p>
              Tu número de socio <strong>601547029</strong>
            </p>
          </div>
        </div>
      </section>

      <section className="o-section--giant__top u-padding-bottom-hero section--background-color">
        <div className="container-inner">
          <div className="grupo-tarjetas">
            <div className="img-tarjeta">
              <img
                src={clubCreditoCaprabo}
                alt="Tarjeta Eroski Club y tarejta mastercard"
              />
            </div>
          </div>

          <div className="tarjeta__content">
            <h2 className="bloque-datos__title">
              <span className="divider__square brand-color" />
              <span className="u-margin-right">Club Caprabo</span>
            </h2>

            <div className="u-display-flex-tablet u-justify-content-flex-start">
              <div className="bloque-socio">
                <p className="title__medium u-margin-bottom-small">
                  ¿No dispones de tu tarjeta?
                </p>
                <p className="u-margin-bottom-medium">
                  Descargar{' '}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="" className="link link-demi">
                    tarjeta temporal
                  </a>
                </p>

                <p className="title__medium u-margin-bottom-small">
                  ¿Quiéres añadir algún adicional?
                </p>
                <p>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                  <a
                    onClick={() => {
                      setShowSolicitud(true);
                      document.body.classList.add('fix');
                    }}
                    className="link link-demi open-solicitar"
                  >
                    Añadir adicional
                  </a>
                </p>
              </div>

              <div className="bloque-socio">
                <form method="post">
                  <fieldset>
                    <legend className="title__medium u-margin-bottom-small">
                      ¿Necesitas otra tarjeta para ti o tu familia?
                    </legend>
                    <ul className="u-margin-bottom-medium">
                      <li className="u-margin-bottom">
                        <div className="radio radio-inline">
                          <input
                            type="radio"
                            id="perdida"
                            value="perdida"
                            name="necesitastarjeta"
                            className="form-control"
                          />
                          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                          <label htmlFor="perdida" className="control-label">
                            Si, la he perdido o está estropeada
                          </label>
                        </div>
                      </li>

                      <li className="u-margin-bottom">
                        <div className="radio radio-inline">
                          <input
                            type="radio"
                            value="familia"
                            id="familia"
                            name="necesitastarjeta"
                            className="form-control"
                          />
                          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                          <label htmlFor="familia" className="control-label">
                            Si, la quiero para un familiar
                          </label>
                        </div>
                      </li>
                    </ul>
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                    <span
                      onClick={() => setShowModal(true)}
                      className="link link-demi"
                    >
                      Solicitar
                    </span>
                  </fieldset>
                </form>
              </div>
            </div>
            <div className="divider small" />

            <h2 className="bloque-datos__title">
              <span className="divider__square brand-color" />
              <span className="u-margin-right">Tarjeta de crédito</span>
            </h2>

            <div className="u-display-flex-tablet u-justify-content-flex-start">
              <div className="bloque-socio">
                <p className="title__medium u-margin-bottom-small">
                  ¿Quieres consultar tus movimientos?
                </p>
                <p>
                  Ir a {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="" className="link link-demi">
                    consultas y gestiones
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>{' '}
      </section>

      <section className="o-section--superhero tarjetas">
        <div className="container">
          <h2 className="titulo-pagina u-text-brand u-text-center">
            Ahora más con estas tarjetas
          </h2>
          <div className="bloque-tarjeta bloque-tarjeta__oro">
            <p className="etiqueta oro">Tarjeta Oro</p>

            <div className="bloque-tarjeta__contenido">
              <div className="img">
                <img
                  src="../../assets/images/img-oro.png"
                  alt="Colage de imagenes"
                />
              </div>

              <div className="bloque-tarjeta__content">
                <p className="title__medium u-margin-bottom-small">
                  Ahorra el 4% en todo lo que compres en Eroski
                </p>
                <p className="u-margin-bottom-small">
                  En alimentación hogar, gasolina, cuando hagas un viaje, ¡hasta
                  en las gafas!
                </p>

                <ul className="lista-ventajas">
                  <li className="lista-ventajas__item">
                    <IconCerdito />

                    <span>Gratis el primer mes</span>
                  </li>
                  <li className="lista-ventajas__item">
                    <IconCalendarioTarjeta />
                    <span>Sin compromiso de permanencia</span>
                  </li>
                  <li className="lista-ventajas__item">
                    <IconPorcentaje classCss="fill-oro" />
                    <span>Acumulable al resto de ofertas y promociones(*)</span>
                  </li>
                </ul>

                <div className="botonera">
                  <button
                    type="button"
                    className="btn btn-secundary btn-secundary__oro"
                  >
                    Mas información
                  </button>
                  <button type="button" className="btn btn-oro">
                    Solicitar
                  </button>
                </div>
              </div>
            </div>
            <p className="legal">
              *En viajes EROSKI no es acumulable a otros descuentos. Consulta el
              resto de condiciones{' '}
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="" className="link">
                aquí
              </a>
            </p>
          </div>
        </div>
      </section>
      <TarjetaForm visible={showSolicitud} setVisible={setShowSolicitud} />
      <AdicionalModal visible={showModal} setVisible={setShowModal} />
    </>
  );
};

export default TitularTpecCaprabo;
